import { Injectable } from '@angular/core';
import { environment } from "../../environments/environment";
import { BehaviorSubject, Observable } from "rxjs";
import { filter, switchMap } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { Deserialize } from "cerialize";
import { Document } from "../models/document/document";

@Injectable({
  providedIn: 'root'
})
export class DocumentConstructeurService {

  baseApiUrl: string = environment.api.baseUrl;

  protected _conseilles: BehaviorSubject<Document[]> = new BehaviorSubject(null);
  public readonly conseilles: Observable<Document[]> = this._conseilles.asObservable().pipe(filter(conseilles => conseilles != null));

  protected _autres: BehaviorSubject<Document[]> = new BehaviorSubject(null);
  public readonly autres: Observable<Document[]> = this._autres.asObservable().pipe(filter(autres => autres != null));

  constructor(private http: HttpClient) {
  }

  loadConseilles(logementId: number): Observable<Document[]> {
    return this.http.get(`${this.baseApiUrl}documents/conseilles/${logementId}`).pipe(switchMap(data => {
        this._conseilles.next(Deserialize(data, Document));
        return this.conseilles;
      })
    );
  }

  loadAutres(logementId: number): Observable<Document[]> {
    return this.http.get(`${this.baseApiUrl}documents/autres/${logementId}`).pipe(switchMap(data => {
        this._autres.next(Deserialize(data, Document));
        return this.autres;
      })
    );
  }
}
